import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ClipboardIcon from '../../icons/ClipboardIcon';
import Clipboard from '../Clipboard';
import CheckboxIcon from '../../icons/CheckboxIcon';

const propTypes = {
  className: PropTypes.string,
  iconProps: PropTypes.object,
  text: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

const ShareUrlClipboardButton = ({ className, iconProps, text, children }) => {
  const classes = classNames({
    [className]: !!className,
  });

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => setCopied(false), 5000);
    }
  }, [copied]);

  return (
    <Clipboard text={text} className={classes} onCopied={() => setCopied(true)}>
      <span className="share-url-clipboard-icon">
        <ClipboardIcon size={32} {...iconProps} />
        {children}
        {copied && <CheckboxIcon className="share-url-checkbox-icon" />}
      </span>
    </Clipboard>
  );
};

ShareUrlClipboardButton.propTypes = propTypes;

export default ShareUrlClipboardButton;
